import { z } from 'zod';
export const idSchema = z.string().uuid();
export const emailSchema = z.string().email().max(254).toLowerCase().trim();
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
    sort: z.string().optional(),
});
//# sourceMappingURL=common.js.map